import EzController from 'controllers/ez-base-controller';
import SearchStateManager from 'lib/search-state';

export default class BrowseController extends EzController {
  connect() {
    const searchState = new SearchStateManager();
    searchState.setDefaultState();
  }
}
